// WIP template experiment setup

import React from "react";
import { createTrackingUtils } from "utils/experiments";
import useUserAgent from "hooks/useUserAgent";
import { UIRebookFLow } from "@flights/types";

export const trackRebookFlowExperiment = createTrackingUtils({
  defaultStage: 1,
  name: "flights_web_pb_rebook_self_serve_m1",
  stages: {
    AFFECTED_USERS: 1,
    ORDER_DETAILS_PAGE: 2,
    ORDER_DETAILS_PAGE_DESKTOP: 3,
    ORDER_DETAILS_PAGE_MDOT: 4
  },
  goals: {},
  goalsWithValue: []
});

export const useTrackRebookFlowExperiment = (rebookFlow?: UIRebookFLow | null) => {
  const { isMobile } = useUserAgent();

  const isChangeTripYourself = rebookFlow === "CHANGE_TRIP_YOURSELF";

  React.useEffect(() => {
    if (isChangeTripYourself) {
      trackRebookFlowExperiment.stages.ORDER_DETAILS_PAGE();

      if (isMobile) {
        trackRebookFlowExperiment.stages.ORDER_DETAILS_PAGE_MDOT();
      } else {
        trackRebookFlowExperiment.stages.ORDER_DETAILS_PAGE_DESKTOP();
      }
    }
  }, [isMobile, isChangeTripYourself]);

  return {
    isRebookFlowExperimentInVariant: isChangeTripYourself && trackRebookFlowExperiment.trackWithDefaultStage() === 1
  };
};
